import script from "./Customerlist.vue?vue&type=script&setup=true&lang=js"
export * from "./Customerlist.vue?vue&type=script&setup=true&lang=js"

import "./Customerlist.vue?vue&type=style&index=0&id=56438e82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56438e82"]])

export default __exports__